function formatStatus(status) {
	return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
}

export {formatStatus}